var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-sheet',_vm._g(_vm._b({staticClass:"ng-sheet",class:{
    ..._vm.sizeClasses,
    'ng-sheet--outlined':
      _vm.$attrs.outlined !== undefined && _vm.$attrs.outlined !== false,
    'ng-sheet--outlined-with-bg': !!_vm.outlinedBg,
  },style:(_vm.cssStyles),attrs:{"rounded":""}},'v-sheet',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }